import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Admin from "apis/Admin";

// First, create the thunk
export const loginRequest = createAsyncThunk("login", async (args) => {
  const [data, callback] = args;
  const response = await Admin.post("signInDashboard", data);
  console.log(response,"response login")
  localStorage.setItem("token", response.data.data.token);
  localStorage.setItem("loginType", response.data.data.data.loginType);
  callback();
  return response.data.token;
});

// Then, handle actions in your reducers:
const loginSlice = createSlice({
  name: "auth",
  initialState: { token: "", message: "",  loading: false },
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    logOut(_state, _action) {
      localStorage.removeItem("token");
      window.location.reload();
      return [];
    },
  },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
    [loginRequest.fulfilled]: (state, action) => {
      // Add key to the state array
      return { ...state, token: action.payload, message: "", loading: false };
    },
    [loginRequest.pending]: (state) => {
      return { ...state, loading: true };
    },
    [loginRequest.rejected]: (state, action) => {
      return {
        ...state,
        token: action.payload,
        message: "Incorrect Email or Password",
        loading: false,
      };
    },
  },
});

export const { logOut } = loginSlice.actions;

export default loginSlice.reducer;
